 <!--
    2019-09-03, GM Created file
 -->

<template>
  <div class="login-page container">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <b-notification
        type="is-warning"
        aria-close-label="Close notification"
        role="alert"
        :active.sync="showErrorMsg">
        {{errorMsg}}
    </b-notification>
    <div class="columns is-centered">

        <form id="payment-form">
          <div id="card-container"></div>
          <button id="card-button" class="button-credit-card" @click="getCard" type="button">Add Card</button>
        </form>
        <div id="payment-status-container"></div>
  
   </div>
  </div>
</template>


<script>
  import sharedAPI from "@/api/SharedAPI.js";
  import store from "../store.js";
  import axios from "axios";
  import { Client, Environment, ApiError } from "square";

  //SANDBOX
  // const appId = 'sandbox-sq0idb-vCgmEgA0dcpVr-SJmSRViQ'
  // const locationId = '1XDKJ20DR6TVX';

  // LIVE
  const appId = 'sq0idp-r2WjpqEi9vs-kT3gKVzvrg'
  const locationId = 'Z6XV1KRPNJH9G';

  export default {
    name: "PaymentForm",
    paymentFormSq: null,
    data() {
      return {
        showErrorMsg: false,
        errorMsg: null,
        isLoading: false,
        isFullPage: true,
        recordID: null,
        customerSqID: null,
        customer: {},
        cardInstance: undefined
      };
    },

    async mounted(){
      this.loadData();
      const payments = window.Square.payments(appId, locationId);
      this.cardInstance = await payments.card();
      this.cardInstance.attach('#card-container');
    },

    methods: {
        async getCard(){
          try{
            var self = this
            const token = await this.cardInstance.tokenize();
            if(token.errors){
              throw(token.errors[0])
            }else{
              var cnonce = token.token
            }

            self.isLoading = true;
            var scriptParameters = `{
              "wholesalerID" : "${self.customer.__kptID}",
              "cardnonce" : "${cnonce}"
            }`;

            var result = await sharedAPI.runScript("Wholesale - Web Log - Update Customer Card", scriptParameters)
            self.isLoading = false;
            var scriptResult = JSON.parse(result.response.scriptResult)

            // FM error
            if(scriptResult.isSuccessful !== 1){
              self.$root.$children[0].$refs.toast.error(scriptResult.error, "Error");
              return;
            }

            self.$router.replace({ name: 'paymentSuccess'});
            self.$root.$children[0].$refs.toast.success("Card Added", "Success")
          }catch(e){
            self.isLoading = false;
            console.log(e.message)
            self.$root.$children[0].$refs.toast.error(e.message, "Error");
          }

        },


        loadData: function() {
            var self = this;
            this.recordID = this.$route.params.id;

            //grab customer details
            axios.post (`proxy.php?/layouts/wholesaler-square-lookup/_find`, 
            {query: [
              { __kptID : '=' + self.recordID }
              ]
            }
            )
            .then(response=>{
              var parse = response.data.response.data;
              
              parse.forEach (function (element) {
                self.customer = response.data.response.data[0].fieldData;
              });

            }).catch(error=>{
              console.log(error);
              self.errorMsg = error;
              self.showErrorMsg = true;
            })

            // this.paymentFormSq = new SqPaymentForm({
            //   applicationId: "sq0idp-r2WjpqEi9vs-kT3gKVzvrg", //"sandbox-sq0idb-vCgmEgA0dcpVr-SJmSRViQ",
            //   inputClass: 'sq-input',
            //   autoBuild: false,
            //   card: {
            //     elementId: 'sq-card',
            //   },

            //   callbacks: {
            //     cardNonceResponseReceived: async function(errors, nonce, paymentData, contacts) {
            //       if (errors) {
            //     //   Log errors from nonce generation to the browser developer console.
            //         console.error('Encountered errors on card nonce received:');
            //         errors.forEach(function (error) {
            //           console.error('  ' + error.message);
            //           this.errorMsg = error.message;
            //         });
            //         alert('Encountered errors, check console for more details');
            //         return;
            //       } else {
            //         //alert(`The generated nonce is:\n${nonce}`);
            //         //TODO: Replace alert with code in step 2.1
            //         //update card
            //         self.isLoading = true;
            //         var scriptParameters = `{
            //           "wholesalerID" : "${self.customer.__kptID}",
            //           "cardnonce" : "${nonce}"
            //         }`;

            //         const result = await sharedAPI.runScript("Wholesale - Web Log - Update Customer Card", scriptParameters)
            //         var scriptResult = JSON.parse(result.response.scriptResult)
            //         self.isLoading = false;

            //         // FM error
            //         if(result.messages[0].code !== "0"){
            //           //FM error
            //           self.$root.$children[0].$refs.toast.error(result.messages[0].message, "Error")
            //           return;
            //         }else if (scriptResult.isSuccessful !== 1){
            //           //script error
            //           self.$root.$children[0].$refs.toast.error(scriptResult.error, "Error")
            //           return;
            //         }
            //         self.$router.replace({ name: 'paymentSuccess'});
            //       }
            //     }
            //   }
            // });

            // this.paymentFormSq.build();

            // function submitCardClick(event) {
            //   event.preventDefault();
            //   // Request a nonce from the SqPaymentForm object
            //   this.paymentFormSq.requestCardNonce();
            // }
        },

        // verifyAndCreateCustomer: function() {
        //     var self = this;
        //     var accessToken = "EAAAEKLGQWV7sax5bEpR6xbp8AhH-vzl-W2MxYNBxW5W5b_YWpciWX-kbfVQqk_N";

        //     if (customer.customerSqID) {
        //       return true;
        //     }

        //     //build customer json
        //     var customerSq = {
        //       given_name: self.customer.nameFirst,
        //       family_name: self.customer.nameLast,
        //       company_name: self.customer.companyName,
        //       email_address: self.customer.email,
        //       phone_numebr: self.customer.phone
        //     } ;
        // },

        // submitCardClick: function(event) {
        //     //event.preventDefault();
        //     var self = this;

        //     //check customer
        //     if (!self.customer.__kptID) {
        //       self.showErrorMsg = true;
        //       self.errorMsg = "Could not find wholesaler. Please re-try from Wholesale data entry screen."
        //     } 

        //     // Request a nonce from the SqPaymentForm object
        //     this.paymentFormSq.requestCardNonce();
        // }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    * {
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    body, html {
      background-color: #F7F8F9;
      color: #373F4A;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-weight: normal;
      height: 100%;
    }

    button {
      border: 0;
      font-weight: 500;
    }

    fieldset {
      margin: 0;
      padding: 0;
      border: 0;
    }

    #form-container {
      position: relative;
      width: 380px;
      margin: 0 auto;
      top: 50%;
      transform: translateY(-50%);
    }

    .third {
      float: left;
      width: calc((100% - 32px) / 3);
      padding: 0;
      margin: 0 16px 16px 0;
    }

    .third:last-of-type {
      margin-right: 0;
    }

    /* Define how SqPaymentForm iframes should look */
    .sq-input {
      height: 56px;
      box-sizing: border-box;
      border: 1px solid #E0E2E3;
      background-color: white;
      border-radius: 6px;
      display: inline-block;
      -webkit-transition: border-color .2s ease-in-out;
        -moz-transition: border-color .2s ease-in-out;
          -ms-transition: border-color .2s ease-in-out;
              transition: border-color .2s ease-in-out;
    }

    /* Define how SqPaymentForm iframes should look when they have focus */
    .sq-input--focus {
      border: 1px solid #6E4EEC;
    }

    /* Define how SqPaymentForm iframes should look when they contain invalid values */
    .sq-input--error {
      border: 1px solid #E02F2F;
    }

    #sq-card-number {
      margin-bottom: 16px;
    }

    /* Customize the "Pay with Credit Card" button */
    .button-credit-card {
      border-radius: 50px;
      box-shadow:
        0px 2px 8px rgba(0, 0, 0, 0.08),
        0px 1px 3px rgba(0, 0, 0, 0.04);
      height: auto;
      font-size: 16px;
      letter-spacing: 0.5px;
      line-height: 24px;
      margin-top: 16px;
      padding: 16px;
      position: relative;
      text-transform: uppercase;
      width: 100%;
      z-index: 1;
      background: linear-gradient(180deg,#8E72FF -57.14%,#6E4EEC 125%);
      border: none;
      color: #fff;
    }

    .button-credit-card:hover {
      background: linear-gradient(180deg,#a791ff -57.14%,#856aef 125%);
      color: #fff;
    }


    .has-text-danger {
      padding-bottom: 20px;
    }
    .center {
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    .card-container {
      padding: 2rem;
      margin: 0px 20px 20px 20px;
    }
    /*.field-container {*/
    /*  background-color: #FFFFFF;*/
    /*  border: solid 1px #cccccc;*/
    /*  border-radius: 5px;*/
    /*  padding: 2rem;*/
    /*  margin: 0px 20px 20px 20px;*/
    /*}  */
</style>
